import {
  AuthenticationError,
  AuthenticationRequiredError,
  BrowserAuthManager,
} from "@groundspark/browser-auth";
import type { AppConfig } from "./config";

export { AuthenticationError, AuthenticationRequiredError };

export class AuthManager extends BrowserAuthManager {
  public constructor(config: AppConfig) {
    super(config, "groundspark_intelligence_session_v2");
  }
}
